import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import {
  buildPageTitle,
  DEFAULT_DESCRIPTION,
  DEFAULT_OG_IMAGE,
  SITE_NAME,
  SITE_URL,
  toAbsoluteUrl,
} from '../lib/seo';

export default function Seo({
  title,
  description = DEFAULT_DESCRIPTION,
  path,
  image = DEFAULT_OG_IMAGE,
  type = 'website',
  noindex = false,
  jsonLd,
}) {
  const location = useLocation();
  const pathname = path || location.pathname;
  const canonical = toAbsoluteUrl(pathname);
  const imageUrl = toAbsoluteUrl(image);

  return (
    <Helmet>
      <title>{buildPageTitle(title)}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="ja_JP" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={buildPageTitle(title)} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={imageUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={buildPageTitle(title)} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      {noindex ? (
        <>
          <meta name="robots" content="noindex, nofollow" />
          <meta name="googlebot" content="noindex, nofollow" />
        </>
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      {jsonLd ? <script type="application/ld+json">{JSON.stringify(jsonLd)}</script> : null}
      <meta name="application-name" content={SITE_NAME} />
      <meta name="apple-mobile-web-app-title" content={SITE_NAME} />
      <meta name="publisher" content={SITE_NAME} />
      <meta name="format-detection" content="telephone=no" />
      <meta property="og:image:alt" content={SITE_NAME} />
      <meta name="theme-color" content="#f4f7f5" />
      <meta name="author" content={SITE_NAME} />
      <meta name="identifier-URL" content={SITE_URL} />
    </Helmet>
  );
}
